<template>
  <section>
    <div class="form-content">
      <el-form-item label="调出公司">
        <el-col :span="10">
          <el-select size="small" class="organization-select" v-model="form.depId" placeholder="请选择调出公司">
            <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-col>
      </el-form-item>
      <el-form-item label="调入公司">
        <el-col :span="10">
          <el-select size="small" class="organization-select" v-model="form.inDepId" placeholder="请选择调入公司">
            <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-col>
      </el-form-item>

      <el-form-item label="资产明细">
        <section class="asset-list">
          <div class="r">
            <el-button @click="AddAsset()" type="primary" size="mini">添加需要调拨的资产</el-button>
          </div>
          <div class="asset-table">
            <el-table :data="selectAssets" border>
              <el-table-column prop="number" label="资产编号" width="110px">
              </el-table-column>
              <el-table-column prop="name" label="资产名称">
              </el-table-column>
              <el-table-column prop="attribute.name" label="资产属性" width="90px">
              </el-table-column>
              <el-table-column prop="spec" label="规格型号" width="140px">
              </el-table-column>
              <el-table-column prop="price" label="购置金额" width="75px">
              </el-table-column>
              <el-table-column prop="purchaseTime" label="购置时间" width="110px">
              </el-table-column>

              <el-table-column label="操作" width="60" align="right">
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="点击删除" placement="bottom">
                    <i @click="AssetDelete(scope.$index)" class="iconfont icon-close meeting-btn-icon mbi-remove"></i>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </section>
      </el-form-item>
      <el-form-item label="调拨原因">
        <el-input type="textarea" placeholder="资产调拨原因简述" :autosize="{ minRows: 3, maxRows: 6}" size="small"
          v-model="form.reason"></el-input>
      </el-form-item>
    </div>

    <!-- 添加资产 -->
    <div class="pop-room" v-if="addStatus">
      <a href="javascript:;" @click="addStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="22">
          <el-form ref="selectAssetForm" :model="selectAssetForm" label-width="120px" class="form">
            <el-form-item label="转移资产">
              <el-select size="small" filterable class="organization-select" v-model="nowAssetId"
                placeholder="请选择需要转移的资产">
                <el-option v-for="item in assetList" :key="item.id" :label="item.name+'('+item.number+')'"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-button @click="AddBtnClick()" class="form-btn" type="success">确认提交</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>

  </section>

</template>
<script>
  import {
    mapState
  } from "vuex";

  export default {
    computed: {
      ...mapState({
        organization: state => state.main.organization,
      })
    },
    props: ['formByFather', 'userData', 'isBack'],
    data() {
      return {
        form: {},

        selectAssetForm: {},
        selectAssets: [],
        nowAsset: {},
        nowAssetId: '',
        addType: 0,
        editIndex: '',

        addStatus: false,
      }
    },
    created() {
      this.organizationListData = this.organization[0].childDepts
      this.depId = this.userData.secDepIds.split(",")[0] / 1
    },
    mounted() {
      this.form = this.formByFather
    },
    methods: {
      // 从列表里删除当前资产
      AssetDelete(index) {
        this.selectAssets.splice(index, 1)
      },
      // 显示添加资产弹窗
      AddAsset() {
        if (!this.form.depId) {
          this.$message.error("请先选择资产调出公司")
          return
        }
        this.nowAsset = {}
        this.nowAssetId = ""
        this.addType = 0
        this.addStatus = true
      },
      // 添加资产到列表
      AddBtnClick() {
        for (let i = 0; i < this.assetList.length; i++) {
          let _item = this.assetList[i]
          if (_item.id == this.nowAssetId) {
            this.nowAsset = _item
          }
        }
        this.selectAssets.push(this.nowAsset)
        this.addStatus = false
      },
      // 获取资产基础资料列表
      getAssetList() {
        ajax.get('/asset/list', {
          'depId': this.form.depId
        }, (res) => {
          this.loading = false
          this.assetList = res.vo.array
        })
      },
      // 返回form
      getFromData() {
        this.form.assetIds = this.selectAssets.map(item => item.id)
        return this.form
      }
    },
    watch: {
      "form.depId"() {
        this.getAssetList()
      },
      formByFather() {
        this.form = this.formByFather
        this.selectAssets = this.form.assets
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/asset/allot.vue